import {
    ChangeDetectionStrategy,
    Component,
} from '@angular/core';
import {
    ITask,
    TaskStatus,
} from '@models';
import { JobTriggerBaseComponent } from '@pages/jobs/grids/job-triggers';
import { TaskService } from '@services';

@Component({
    selector: 'ui-job-trigger-task',
    templateUrl: './job-trigger-task.component.html',
    styleUrls: ['./job-trigger-task.component.scss'],
    providers: [TaskService],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobTriggerTaskComponent extends JobTriggerBaseComponent<ITask> {

    public TaskStatus = TaskStatus;

    constructor(private _taskService: TaskService) {
        super();
    }

    protected _fetchItem = () => this._taskService.getInstance(this._itemId, ['AssignedToUser']);
}
